import type { ChatRoomCreateRequestRoomInfo } from './chatRoomCreateRequestRoomInfo';

export interface ChatRoomCreateRequest {
  /** 참여자 ID 목록 */
  participantIds: number[];
  /** 채팅방 정보 */
  roomInfo?: ChatRoomCreateRequestRoomInfo;
}
